
















import { Component, Vue, Watch, Prop, Model } from 'vue-property-decorator';
import ExamForm from '@/components/ExamForm.vue';
import { CourseCenterApplicationController } from '../services/request.service';

@Component({
  components: {
    ExamForm,
  },
})
export default class CompleteScoreModal extends Vue {
  @Prop({ default: false }) public visible!: boolean;
  @Prop() public studentId!: number;
  public visibleOfModal: boolean = false;
  public loading: boolean = false;
  public formValue: any = {};
  public draftInfo: any = {};

  @Watch('visible', { immediate: true })
  public changeVisible(): void {
    this.visibleOfModal = this.visible;
    if (this.studentId && this.studentId !== -1) {
      this.getExamValue();
    }
  }

  public get locale(): string {
    return this.$i18n.locale;
  }

  public getExamValue(): void {
    CourseCenterApplicationController.getExamResultDetail(this.studentId).then(res => {
      this.draftInfo = res.data;
    });
  }

  public handleOk(e: Event): void {
    const ref: any = this.$refs.examForm;
    ref && ref.getExamFormInfo(e);
    if (this.formValue) {
      this.formValue.examResultId = this.draftInfo.examResultId;
      this.formValue.studentId = this.studentId;
      CourseCenterApplicationController.updateExamResult(this.formValue).then(res => {
        this.$message.success(this.$tc('warningTip.modifyMobileSuccess'));
        this.$emit('change', false);
        this.$emit('reset');
      });
    }
  }

  public getValue(value: any): void {
    this.formValue = value;
  }

  public handleCancel(): void {
    this.visibleOfModal = false;
    this.$emit('change', false);
    this.loading = false;
  }
}
